import type { ContractType } from "../../types";

export interface TaskBreakdownRow {
  index: number;
  score: number;
  type: ContractType | undefined;
}

/**
 * Rows for the per-task breakdown on the result screen. Iterates the stored
 * scores (never the live contract), so a contract whose task list changed - or
 * was removed from the catalog - still shows every saved score. The label comes
 * from the per-task types stored with the entry, falls back to the live task
 * list, and is left undefined when neither covers the index (the screen then
 * shows a neutral "Задача N").
 */
export function taskBreakdownRows(
  taskScores: readonly number[],
  taskTypes: readonly ContractType[] | undefined,
  contractTasks: readonly ContractType[] | undefined,
): TaskBreakdownRow[] {
  return taskScores.map((score, index) => ({
    index,
    score,
    type: taskTypes?.[index] ?? contractTasks?.[index],
  }));
}
